import React, { FormEventHandler, Fragment, useRef, useState } from "react";
import "./contact.css";
import "../../../styles/typography.css";
import SectionTitle from "../../Typography/SectionTitle";
import SectionSubtitle from "../../Typography/SectionSubtitle";
import Row from "../../layout/Row";
import Column from "../../layout/Column";
import List from "../../layout/List";
import ListItem from "../../layout/ListItem";
// import Input from "../../layout/Input";
// import Button from "../../layout/Button";

import LocationIcon from "../../icons/LocationIcon";
import PhoneIcon from "../../icons/PhoneIcon";
import MailIcon from "../../icons/MailIcon";
import ContactCard from "../../ContactCard";
import Divider from "../../layout/Divider";

type ContactT = {
    polekontakty: {
        jmenoAPrijmeni: string;
        pozice: string;
        telefon: string;
        email: string;
        doplnkoveInformace: string;
    }
}

interface ContactSectionProps {
    contacts: ContactT[]
}

// type FormValueT = {
//     name: string;
//     phone: string;
//     mail: string;
// }

// const defaultFormValue:FormValueT = {
//     name:"",
//     phone:"",
//     mail:"",
// }

const ContactSection:React.FC<ContactSectionProps> = ({ contacts }) => {

    // @note: removed functionality for mail sending.
    // if needed, discomment code below, types, default values, imports and change env vars 
    // in .env file (production / development) -> GATSBY_WP_URL ;

    // const [isSubmiting, setSubmiting] = useState<boolean>(false);
    // const [formValue, setFormValue] = useState<FormValueT>(defaultFormValue);

    // const onInputFieldChange = (e:React.ChangeEvent<HTMLInputElement>, newVal: string) => {
    //     setFormValue(prev=>{
    //         prev[e.target.name as keyof FormValueT] = newVal;
    //         return prev;
    //     })
    // }

    // @note: endpoint need to be existing at wordpress site. Write your functionality or use some plugin. 

    // const sendMail = async () => {
    //     let uri = process.env.GATSBY_WP_URL + "/wp-json/api/v1/send_mail";
    //     if(uri){
    //         try{
    //             const resp = await fetch(uri, {
    //                 method:"POST",
    //                 headers:{'Content-type':'application/json'},
    //                 body:JSON.stringify({
    //                     name: formValue.name,
    //                     phone: formValue.phone,
    //                     mail: formValue.mail
    //                 })        
    //             });
    //             return resp;
    //         }catch(err){
    //             return { status: 400 }
    //         }
    //     }else{
    //         console.error("chyba při odeslání formuláře");
    //         return {
    //             status: 400,
    //         }
    //     }
    // }

    // const onFormSubmit:FormEventHandler = (e) =>{
    //     e.preventDefault();
    //     setSubmiting(true);
    //     sendMail()
    //     .then((resp)=>{
    //         if(resp && resp.status == 200){
    //             setFormValue({name:"",mail:"",phone:""});
    //             setSubmiting(false);
    //         }else{
    //             console.log("error");
    //             setSubmiting(false);
    //         }
    //     });
    // }

    return (
        <section id="contact" className="contact-section">
            <div className="container">
                <SectionTitle>Kontakt</SectionTitle>
                <SectionSubtitle>Ozvěte se nám</SectionSubtitle>
                <div className="max-w-6xl p-4 lg:border-2 rounded-sm m-auto mt-8" style={{background: "#fff"}}>
                    <Row>
                        <Column aria-label="mapa">
                        <iframe 
                        style={{border:'none', borderRadius:"4px"}} 
                        src="https://frame.mapy.cz/s/gelacaguna" 
                        width="100%" 
                        height="280" 
                        frameBorder={0}></iframe>
                        </Column>
                        <Column aria-label="kontaktní informace">
                            <List>
                                <ListItem 
                                icon={<PhoneIcon />}
                                primary="telefon"
                                secondary="+420 608 348 184"
                                />
                                <ListItem 
                                icon={<MailIcon/>}
                                primary="email"
                                secondary="info@stavbysever.cz"
                                />
                                <ListItem 
                                icon={<LocationIcon />} 
                                primary="adresa provozovny"
                                secondary={
                                    <>
                                    <ul className="mb-4">
                                        <li className="font-bold">TMR - stavby sever s.r.o.</li>
                                        <li>Řetenická</li>
                                        <li>415 01 Teplice</li>
                                        <li>Česká republika</li>
                                    </ul>
                                    </>
                                }
                                />
                            </List>
                        </Column>
                        <Column>
                        { contacts && contacts.map((contact, index)=>(
                            <Fragment key={contact.polekontakty.jmenoAPrijmeni + index}>
                                <ContactCard 
                                    name={contact.polekontakty.jmenoAPrijmeni}
                                    position={contact.polekontakty.pozice}
                                    phone={contact.polekontakty.telefon}
                                    mail={contact.polekontakty.email}
                                    additional={contact.polekontakty.doplnkoveInformace !== "" ? contact.polekontakty.doplnkoveInformace : undefined}
                                />
                                {index < contacts.length - 1 ? <Divider /> : null}
                            </Fragment>
                        ))}
                            {/* <ContactCard 
                                name="Tomáš Melzer"
                                position="jednatel"
                                phone="608 348 184"
                                mail="tomas.melzer@stavbysever.cz"
                            />
                            <Divider />
                            <ContactCard 
                                name="Tomáš Ráža"
                                position="jednatel"
                                phone="602 602 212"
                                mail="tomas.raza@stavbysever.cz"
                            />
                            <Divider />
                            <ContactCard 
                                name="Lukáš Anděl"
                                position="stavbyvedoucí"
                                phone="608 941 556"
                                mail="lukas.andel@stavbysever.cz"
                            />
                            <Divider />
                            <ContactCard 
                                name="Dominika Kršňáková"
                                position="fakturace, účetnictví"
                                phone="604 792 772"
                                mail="ucetni@stavbysever.cz"
                                additional="(*email pro zasílání faktur)"
                            /> */}
                        </Column>
                    </Row>
                    <div style={{height:1, width:"100%", background:"var(--text-primary)", marginBottom:16, opacity:.3, marginTop: 16}}></div>
                    <Row>
                        <Column>
                            <ul
                            className="flex flex-col lg:flex-row items-center lg:justify-between w-full mt-8 lg:mt-0" 
                            style={{color:"var(--text-secondary)", opacity:0.5}}
                            >
                                <li>IČ: 17821347</li>
                                <li>DIČ: CZ17821347</li>
                                <li>ID datové schránky: vzmx46x</li>
                                <li>č.ú. 638 762 8309 / 0800</li>
                            </ul>
                            <ul
                            className="flex flex-col items-center w-full mt-4 justify-center"
                            style={{color:"var(--text-secondary)", opacity:0.5}}
                            >
                                <li style={{fontWeight:"bold"}}>Sídlo společnosti:</li>
                                <li>TMR-Stavby sever s.r.o</li>
                                <li>gen. Svobody 1193</li>
                                <li>415 01 Teplice</li>
                            </ul>
                        </Column>
                    </Row>
                </div>
            </div>
        </section>
    )
}

export default ContactSection;